import { select, brushY, event } from 'd3'
import Highcharts from 'highcharts'

const updateRangeValue = (extentValue, range): number =>
    Math.floor((extentValue * (range[1] - range[0])) / 613 + range[0])

export const zoomFunction = (el, updatedRange, setUpdatedRange, range): void => {
    var schematic = select(el)

    schematic.selectAll('.brush, .reset-zoom').remove()

    var brush = brushY()
        .extent([
            [0, 0],
            [el.getBoundingClientRect().width, el.getBoundingClientRect().height]
        ])
        .on('end', () => {
            let extent = event.selection

            if (extent) {
                let newRange = [updateRangeValue(extent[0], updatedRange), updateRangeValue(extent[1], updatedRange)]
                setUpdatedRange(newRange)
                schematic.selectAll('.reset-zoom').style('display', 'unset')
                schematic.select('.brush').call(brush.move, null)

                const event = new CustomEvent('zoomOGMW', {
                    detail: { zoom: newRange }
                })
                document.dispatchEvent(event)

                Highcharts.charts.map(e =>
                    e !== undefined && e.userOptions.chart.className === 'OGMW-cartesian'
                        ? e.xAxis[0].setExtremes(newRange[0], newRange[1])
                        : null
                )
            }
        })

    schematic
        .append('g')
        .attr('class', 'brush')
        .call(brush)

    resetZoomButton(el, range, updatedRange)
}

const resetZoomEvent = () => {
    const event = new CustomEvent('zoomOGMW', {
        detail: { zoom: [] }
    })
    document.dispatchEvent(event)
    Highcharts.charts.map(e =>
        e !== undefined && e.userOptions.chart.className === 'OGMW-cartesian'
            ? e.xAxis[0].setExtremes(null, null)
            : null
    )
}

export const resetZoomButton = (el, range, updatedRange): void => {
    var schematic = select(el)

    var resetZoom = schematic
        .append('g')
        .attr('class', 'reset-zoom')
        .style('display', JSON.stringify(updatedRange) !== JSON.stringify(range) ? 'unset' : 'none')
        .on('click', () => resetZoomEvent())

    resetZoom.append('title').text('Reset zoom level 1:1')

    resetZoom
        .append('rect')
        .attr('width', 80)
        .attr('height', 30)

    resetZoom
        .append('text')
        .text('Reset zoom')
        .attr('x', 10)
        .attr('y', 20)
        .attr('rx', 2)
        .attr('ry', 2)
}
